 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		1: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"admiral2","2":"atlas","3":"atlasbet","4":"atlasbrl","5":"atlascad","6":"atlasclp","7":"atlaseur","8":"atlasgbp","9":"atlasinr","10":"atlasjpy","11":"atlaskzt","12":"atlasmxn","13":"atlaspen","14":"atlasrub","15":"atlasstaging","16":"atlasthb","17":"atlasuah","18":"atlasusd","19":"atlasusdstaging","20":"atlasuzs","21":"atlaszar","22":"avalonbyn","23":"avaloneur","24":"avalonrub","25":"avalonusd","26":"balkanbet","27":"balkanbetstaging","28":"betasus","29":"betconstruct","30":"betconstructamd","31":"betconstructazn","32":"betconstructbrl","33":"betconstructcad","34":"betconstructcny","35":"betconstructeur","36":"betconstructgbp","37":"betconstructgel","38":"betconstructinr","39":"betconstructirr","40":"betconstructkrw","41":"betconstructkzt","42":"betconstructmyr","43":"betconstructpln","44":"betconstructrub","45":"betconstructsek","46":"betconstructtnd","47":"betconstructtry","48":"betconstructuah","49":"betconstructusd","50":"bethappyeurstaging","51":"bethappytrystaging","52":"bethappyusdstaging","53":"betviliproduction","54":"betvilistaging","55":"betvilixmbproduction","56":"betvilixmbstaging","57":"betworld247","58":"betworld247staging","59":"bifortunacz","60":"blueoceangaming","61":"blueoceangamingall","62":"blueoceangamingars","63":"blueoceangamingaud","64":"blueoceangamingazn","65":"blueoceangamingcad","66":"blueoceangamingchf","67":"blueoceangamingeur","68":"blueoceangaminggbp","69":"blueoceangamingnok","70":"blueoceangamingnzd","71":"blueoceangamingpen","72":"blueoceangamingphp","73":"blueoceangamingpln","74":"blueoceangamingrsd","75":"blueoceangamingrub","76":"blueoceangamingtnd","77":"blueoceangamingtry","78":"blueoceangamingusd","79":"blueoceangamingves","80":"blueoceangamingxmb","81":"bmk","82":"boulparyaj","83":"bugbetstaging","84":"casapariurilor","85":"casapariurilorbuild","86":"casapariurilorstg","87":"cashwin","89":"circus","90":"circusstaging","91":"demo","92":"efortuna","93":"efortunabuildro","94":"efortunastgro","95":"expo","96":"fairplay","97":"fedorastaging","98":"futurebet","99":"gameofbet","100":"gml","101":"gmleur","102":"i18.cs","103":"i18.de","104":"i18.en","105":"i18.es","106":"i18.fr","107":"i18.hr","108":"i18.it","109":"i18.ro","110":"i18.rs","111":"i18.rs-Latn","112":"i18.sl","113":"ifortunabuildcz","114":"ifortunastgcz","115":"kombobet","116":"lonabiss","117":"maxbetsrbstaging","118":"mdshop","119":"mybetplus","120":"noktabet","121":"oynabil","122":"paryerenovacash","123":"pionirinternacional","124":"pionirstaging","125":"piramida","126":"playtech850036","127":"playtech850037","128":"premiumbahis","129":"premiumbahistry","130":"premiumbahisusd","131":"prvafirma","132":"qa","133":"qq288cny","134":"qq288idr","135":"qq288krw","136":"qq288myr","137":"qq288thb","138":"qq288usd","139":"qq288vnd","140":"redfoxbet","141":"rocasino","142":"rocasinoeur","143":"sigma","144":"sportingbookmakers","145":"sportingbookmakersstaging","146":"starsportsbet","147":"starsportsbetstaging","148":"superbetstaging","149":"vbetbrl","150":"vbetcad","151":"vbetcny","152":"vbeteur","153":"vbetgel","154":"vbetkzt","155":"vbetpln","156":"vbetrub","157":"vbetsek","158":"vbettry","159":"vbetusd","160":"victory2brl","161":"victory2eur","162":"victory2usd","163":"victoryeur","164":"victoryngn","165":"victoryusd","166":"wbro","167":"wbrostaging","168":"wettnet","169":"wgbnigeria","170":"winnerstg","171":"worldstarbetting","172":"worldstarbettingmwk","173":"worldstarbettingzmw"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([410,88]);
 	// run deferred modules when ready
 	return checkDeferredModules();
